import restClient from "./BackendRestClient";

export function getMilestonesByShipmentId(shipmentId) {
    return restClient.get(["milestone", "shipment-milestones", shipmentId].join("/"))
        .then(res => res)
}

export function getMilestoneTypesAndContainerData(shipmentId) {
    return restClient.get(["milestone", "milestone-types-containers", shipmentId].join("/"))
        .then(res => res)
}

export function getAdditionalMilestoneData(shipmentId, milestoneTypeId) {
    return restClient.get(["milestone", "additional-milestone-data", shipmentId, milestoneTypeId].join("/"))
        .then(res => res)
}

export function addMilestone(milestone) {
    return restClient.post(["milestone", "add-milestone"].join("/"), milestone)
        .then(res => res)
}
